import React, { useLayoutEffect } from "react";

const DisableComponent: React.FC = () => {
  // Uncomment if needed for production-only
   const isProduction = import.meta.env.VITE_APP_ENV === "production";

  useLayoutEffect(() => {
      if (!isProduction) return; 
    // Disable unwanted actions
    const disableEvents = (e: Event) => {
      e.preventDefault();
      e.stopPropagation();
      return false;
    };

    const disableKeyboardShortcuts = (e: KeyboardEvent) => {
      const forbiddenKeys = ["c", "v", "x", "u", "s", "i", "j"];
      if (
        e.ctrlKey ||
        e.metaKey ||
        (e.ctrlKey && forbiddenKeys.includes(e.key.toLowerCase()))
      ) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
    };

    // Attach event listeners directly — no overlay blocking clicks
    const attachListeners = () => {
      document.addEventListener("contextmenu", disableEvents, true);
      document.addEventListener("copy", disableEvents, true);
      document.addEventListener("paste", disableEvents, true);
      document.addEventListener("cut", disableEvents, true);
      document.addEventListener("keydown", disableKeyboardShortcuts, true);
    };

    const detachListeners = () => {
      document.removeEventListener("contextmenu", disableEvents, true);
      document.removeEventListener("copy", disableEvents, true);
      document.removeEventListener("paste", disableEvents, true);
      document.removeEventListener("cut", disableEvents, true);
      document.removeEventListener("keydown", disableKeyboardShortcuts, true);
    };

    attachListeners();

    // Mutation observer in case extensions re-enable right click
    const observer = new MutationObserver(() => {
      attachListeners();
    });
    observer.observe(document.body, { childList: true, subtree: true });

    // Periodically verify listeners exist
    const recheckInterval = window.setInterval(() => {
      attachListeners();
    }, 3000);

    // Detect DevTools
    const detectDevTools = () => {
      const start = performance.now();
      debugger;
      const end = performance.now();
      if (end - start > 10) {
        const overlay = document.createElement("div");
        Object.assign(overlay.style, {
          position: "fixed",
          top: "0",
          left: "0",
          width: "100vw",
          height: "100vh",
          backgroundColor: "rgba(0, 0, 0, 0.9)",
          color: "white",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontSize: "1.5rem",
          zIndex: "9999",
        });
        overlay.innerText = "Developer tools are not allowed on this page.";
        document.body.appendChild(overlay);
      }
    };
    const detectInterval = window.setInterval(detectDevTools, 2000);

    // Cleanup
    return () => {
      detachListeners();
      observer.disconnect();
      clearInterval(detectInterval);
      clearInterval(recheckInterval);
    };
  }, []);

  return null;
};

export default DisableComponent;
